import type { JSX } from '@builder.io/qwik';
import { useContext } from '@builder.io/qwik';
import { Slot, component$ } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';

export default component$((): JSX.Element => {
  const {
    payloadToSSR: { isMobileViewer },
  } = useContext(AppDataContext);

  // Don't show sidebar in mobile
  if (isMobileViewer) return <></>;

  return (
    <div class='hidden lg:block lg:ml-4 lg:w-[calc(30%-1em)]'>
      <Slot />
    </div>
  );
});
